<template>
  <div id="title_part">
    <div class="container">
      <section class="product_info animate__fadeInUp wow" data-wow-duration="0.6s">
        <div class="dayTag">
          <a :href="'/tours/search/' + tour.subcategoryUrl" v-cloak target="_blank" v-if="tour && tour.subcategoryUrl">
            {{ tour && tour.category }} / {{ tour && tour.subcategory }}
          </a>
          <div v-else>{{ tour && tour.category }} / {{ tour && tour.subcategory }}</div>
        </div>
        <h1 class="product_title">{{ tour.title }}</h1>
        <b-row>
          <b-col class="feature" cols="12">
            <h6 class="mb-2">{{ $t('tourHighlight') }}</h6>
            <div v-html="tour.highlight" class="spot_txt"></div>

            <!-- showCourtOpt是的話，跑迴圈把schedule 裡golf的area_id 用在這邊連結 -->
            <!-- 有球場才出現 -->
            <a v-if="tour.showCourtOpt !== '' && tour.showCourtOpt !== '無' && golfAreaId"
              :href="'/tours/golf/' + golfAreaId" target="_blank">
              <b-icon-caret-right-fill></b-icon-caret-right-fill><span class="ml-1">點此瀏覽其他球場</span>
            </a>
            <br>
            <!-- 找旅館的area_id -->
            <a v-if="tour.showCourtOpt !== '' && tour.showCourtOpt !== '無' && hotelAreaId"
              :href="'/tours/hotel/' + hotelAreaId" target="_blank">
              <b-icon-caret-right-fill></b-icon-caret-right-fill><span class="ml-1">點此瀏覽其他旅館</span>
            </a>
          </b-col>
          <b-col class="feature mt-3" cols="12" v-if="tour.normalPrice && tour.normalPrice.adult !== '0'">
            NTD. <span class="product_price">
              {{ tour.normalPrice.adult }}</span> 起
            <div v-if="tour.showRMB"> 約人民幣 ￥<span class="product_price">{{ Math.round(tour.normalPriceRMB.adult)
                }}</span></div>
            <!-- <div v-if="tour.category!=='國內旅遊'">
              (行程及報價僅供參考，因目前航班及飯店、球場、餐廳等都在漲價浮動中。實際以確定日期人數內容後的價錢為主)
            </div> -->
            <div class="mt-3">
              <a href="/tours/price">
                <b-icon-calculator-fill></b-icon-calculator-fill><span class="ml-1">點此測算台灣國內旅遊費用</span>
              </a>
              <br>
              <a href="/tours/price-outbound">
                <b-icon-calculator-fill></b-icon-calculator-fill><span class="ml-1">點此測算國外高爾夫、旅遊費用</span>
              </a>
            </div>
          </b-col>
          <b-col cols="12" class="text-center mb-3">
            <!--  v-if="tour.language==='tw'" -->
            <b-button v-if="tour.language === 'tw'" class="mx-2 book_btn" v-b-modal.sendMail>
              <!-- class="mx-2 book_btn animate__fadeIn wow" data-wow-duration="0.3s" v-b-modal.sendMail> -->
              詢價/報名
            </b-button>
            <!--  v-if="tour.language==='jp'" -->
            <b-button v-if="tour.language === 'jp'" class="mx-2 book_btn" v-b-modal.sendMail>
              予約へ進む
            </b-button>
            <!-- 英文版modal v-if="tour.language==='en'" -->
            <b-button v-if="tour.language === 'en'" class="mx-2 book_btn" v-b-modal.sendMail>
              BOOK NOW
            </b-button>

            <a href="https://tstar888.com/geaw/esim" target="_blank">
              <b-button class="mx-2 book_btn bg_orange animate__fadeIn wow" data-wow-duration="0.3s">
                購買 eSim 網卡
              </b-button>
            </a>

          </b-col>
          <!-- <b-col cols="12" class="share_Link text-center ">
            <span class="share_txt d-md-none pb-2">シェア：</span>
            <b-row>
              <b-col class="px-5">
                <span class="share_txt d-none d-md-inline">シェア：</span>
                <img src="@/assets/img/share/jp_copy_url.png">
                <img src="@/assets/img/share/jp_fb_share.png">
                <img src="@/assets/img/share/jp_line_share.png">
                <img src="@/assets/img/share/jp_share_mail.png">
              </b-col>
            </b-row>
          </b-col> -->

          <!-- 分享按鈕 -->
          <b-col class="share_link mb-3" cols="12">
            <!-- <span class="share_txt">この商品をシェアする：</span> -->
            <!-- <div class="copy_link"><b-icon-link45deg font-scale="1.5"></b-icon-link45deg>複製連結</div>
              <div class="dm">DM下載</div> -->
          </b-col>
        </b-row>
      </section>
    </div>

    <!-- 舊版立刻預約modal -->
    <b-modal id="calendar_modal" scrollable no-stacking size="xl" title="沖繩四天三夜高爾夫之旅" cancel-title="取消"
      @hidden="resetForm">
      <template #modal-footer>
        <div class="w-100">
          <div class="d-flex flex-column float-left">
            <div class="float-left" id="footer_info_date">{{ pickDate }}</div>
            <div class="d-inline-block float-left price" id="footer_info_price">$400</div>
          </div>
          <b-button variant="primary" size="sm" class="float-right" @click="goCheckout"
            :disabled="pickDate === '' || pickDate === '尚未選擇'">
            下一步
          </b-button>
        </div>
      </template>
      <b-row>
        <!-- 1.月曆選擇日期 -->
        <b-col cols="12" lg="6" class="mb-4">
          <div class="modal_head">
            <font-awesome-icon icon="fa-solid fa-1"></font-awesome-icon>選擇日期
          </div>
          <!-- :available-dates=availableDates -->
          <v-date-picker :available-dates=availableDates :first-day-of-week="2" :attributes='attributes'
            :is-expanded="$screens({ default: false, sm: true })"
            :masks="{ title: 'YYYY MMM', dayPopover: 'MMM D , WWW' }" :model-config="modelConfig" color="indigo"
            class="text-center p-0" v-model="pickDate">
          </v-date-picker>
          <div class="date_info">
            <div class="mark_box">
              <div class="dot_mark"></div>
              <span>平日</span>
            </div>
            <div class="mark_box">
              <div class="dot_mark"></div>
              <span>假日</span>
            </div>
            <!-- <div class="mark_box">
                    <div class="dot_mark"></div>
                    <span>特殊價格</span>
                  </div>
                  <div class="mark_box">
                    <div class="dot_mark"></div>
                    <span>特殊價格2</span>
                  </div> -->
            <b-row class="mt-3">
              <b-col cols="6">
                <div class="grey_border">總團位數</div>
                <span class="custom_check">{{ show_day_data.max_people }}</span>
              </b-col>
              <b-col cols="6">
                <div class="grey_border">成行人數</div>
                <span class="custom_check">{{ show_day_data.min_people }}</span>
              </b-col>
              <b-col cols="6">
                <div class="grey_border can_sell">可售人數</div>
                <span class="custom_check">{{ show_day_data.available_people }}</span>
              </b-col>
              <b-col cols="12">
                <div class="grey_border">出發地</div>
                <span class="custom_check">{{ show_day_data.departure_place }}</span>
              </b-col>
              <b-col cols="12">
                <div class="grey_border">備註</div>
                <span class="custom_check">{{ show_day_data.ps }}</span>
              </b-col>
              <!-- <div v-if="customer.date === '尚未選擇' || customer.date ===''"></div>
                    <b-col cols="12" class="mt-2" v-else>
                      <div class="grey_border">選擇日期</div>
                        <span class="custom_check">{{customer.date}} 日本福岡+阿蘇5天3場球(華航.長榮)4人成行</span>
                    </b-col> -->
            </b-row>
            <b-row class="mt-2"></b-row>
          </div>
        </b-col>
        <!-- 月曆 END-->

        <!-- 2.選擇房間 -->
        <b-col v-if="tour.multiPrices === true" cols="12" lg="6">
          <!-- <div class="mb-4">
                  <div class="modal_head">
                    <font-awesome-icon icon="fa-solid fa-2"></font-awesome-icon>選擇房間
                  </div>
                  <div class="row_p20" v-if="pickDate==='尚未選擇'">請先選擇日期</div>
                  <div v-else>
                    <b-row class="row_p20">
                      <b-col cols="6" lg="7">
                        單人房
                      </b-col>
                      <b-col cols="6" lg="5">
                        <b-form-spinbutton
                        id="sb-small"
                        size="sm"
                        v-model="singleRoom"
                        inline
                        min="0"
                        max="10"
                        >
                        </b-form-spinbutton>
                      </b-col>
                    </b-row>
                    <b-row class="row_p20" v-if="show_day_data.room.double.available > 0">
                      <b-col cols="6" lg="7">
                        雙人房
                      </b-col>
                      <b-col cols="6" lg="5">
                        <b-form-spinbutton
                        id="sb-small"
                        size="sm"
                        v-model="doubleRoom"
                        inline
                        min="0"
                        :max="show_day_data.room.double.available"
                        >
                        </b-form-spinbutton>
                      </b-col>
                    </b-row>
                    <b-row class="row_p20" v-if="show_day_data.room.triple.available > 0">
                      <b-col cols="6" lg="7">
                        三人房
                      </b-col>
                      <b-col cols="6" lg="5">
                        <b-form-spinbutton
                        id="sb-small"
                        size="sm"
                        v-model="doubleRoom"
                        inline
                        min="0"
                        max="100"
                        >
                        </b-form-spinbutton>
                      </b-col>
                    </b-row>
                    <b-row class="row_p20" v-if="show_day_data.room.triple.available > 0">
                      <b-col cols="6" lg="7">
                        四人房
                      </b-col>
                      <b-col cols="6" lg="5">
                        <b-form-spinbutton
                        id="sb-small"
                        size="sm"
                        v-model="doubleRoom"
                        inline
                        min="0"
                        max="100"
                        >
                        </b-form-spinbutton>
                      </b-col>
                    </b-row>
                    <b-row class="row_p20">
                      <b-col cols="6" lg="7">
                        通鋪請電洽
                      </b-col>
                    </b-row>
                  </div>
                </div> -->
          <!-- 2.選擇房間END -->

          <!-- 3.選擇人數 -->
          <div class="pick_ppl mb-4">
            <div class="modal_head">
              <font-awesome-icon icon="fa-solid fa-2"></font-awesome-icon>選擇人數
            </div>
            <b-row class="row_p20">
              <b-col>
                <span class="">成人(6歲以上)</span>
              </b-col>
              <b-col>
                <b-form-spinbutton id="sb-small" size="sm" v-model="single.singleAdult" inline min="0" max="">
                </b-form-spinbutton>
              </b-col>
            </b-row>
            <b-row class="row_p20">
              <b-col>
                <span class="">兒童(2-6歲)</span>
              </b-col>
              <b-col>
                <b-form-spinbutton id="sb-small" size="sm" v-model="double.child" inline min="0" max="">
                </b-form-spinbutton>
              </b-col>
            </b-row>
            <div class="row_p20 d-none">
              <div v-if="singleRoom === 0 && doubleRoom === 0">請先選擇房間</div>
              <div :key="index" v-for="(n, index) in singleRoom" class="pick_rooms">
                <template>
                  <div>單人房 {{ n }}</div>
                </template>
                <b-row class="row_p20">
                  <b-col cols="6" lg="7">
                    <span class="identity">成人(6歲以上)</span>
                    <!-- <div class="room_type_price">${{orderForm.normalPrice.single.price}} 佔床</div> -->
                  </b-col>
                  <b-col cols="6" lg="5">
                    <b-form-spinbutton id="sb-small" size="sm" v-model="single.singleAdult" inline min="0"
                      max="1"></b-form-spinbutton>
                  </b-col>
                </b-row>
              </div>
              <div :key="index" v-for="(n, index) in doubleRoom" class="pick_rooms">
                <template>
                  <div>雙人房 {{ n }}</div>
                </template>
                <b-row class="row_p20">
                  <b-col cols="6" lg="7">
                    <span class="identity">成人(6歲以上)</span>
                    <!-- <div class="room_type_price">${{orderForm.normalPrice.double.adult}}</div> -->
                  </b-col>
                  <b-col cols="6" lg="5">
                    <b-form-spinbutton id="sb-small" size="sm" step="2" inline min="0" max="2"
                      v-model="double[n - 1].doubleAdult"></b-form-spinbutton>
                  </b-col>
                </b-row>
                <b-row class="row_p20">
                  <b-col cols="6" lg="7">
                    <span class="identity">兒童(2-6歲)</span>
                    <!-- <div class="room_type_price">${{orderForm.normalPrice.double.child}}</div> -->
                  </b-col>
                  <b-col cols="6" lg="5">
                    <b-form-spinbutton id="sb-small" size="sm" inline v-model="double[n - 1].doubleChild" min="0"
                      max="1"
                      :disabled="double[n - 1].doubleBaby === 1 || double[n - 1].doubleAdult === 0"></b-form-spinbutton>
                  </b-col>
                </b-row>
                <b-row class="row_p20">
                  <b-col cols="6" lg="7">
                    <span class="identity">嬰兒(未滿2歲)</span>
                    <!-- <div class="room_type_price">${{orderForm.normalPrice.double.baby}}</div> -->
                  </b-col>
                  <b-col cols="6" lg="5">
                    <b-form-spinbutton id="sb-small" size="sm" inline min="0" max="1" v-model="double[n - 1].doubleBaby"
                      :disabled="double[n - 1].doubleChild === 1 || double[n - 1].doubleAdult === 0"></b-form-spinbutton>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <!-- 3.選擇人數END -->

          <!-- 4.確認資訊 -->
          <div class="modal_head text-danger">
            <font-awesome-icon icon="fa-solid fa-3"></font-awesome-icon>確認資訊
          </div>
          <div class="border p-2">
            <b-row class="row_p20">
              <div class="grey_border">團名</div>
              <span class="custom_check">{{ tour.title }}</span>
            </b-row>
            <b-row class="row_p20">
              <div class="grey_border">日期</div>
              <span class="custom_check">{{ pickDate }}</span>
            </b-row>
            <b-row class="row_p20">
              <div class="grey_border">總金額</div>
              <span class="custom_check price">{{ orderData.totalPrice }}</span>
            </b-row>
          </div>

          <!-- <b-row class="row_p20">
                  <div class="grey_border">房間人數</div>
                  <span class="custom_check"></span>
                  <b-table class="mt-1" striped small :items="check_rooms" :fields='fields'>
                    <template #cell(amount)="data">
                      <p>成人 x {{double[data.index].doubleAdult}}，兒童 x {{double[data.index].doubleChild}}，嬰兒 x {{double[data.index].doubleBaby}}</p>
                    </template>
                  </b-table>
                </b-row> -->
          <!-- 4.確認資訊END -->
        </b-col>

        <!-- 不用選房間只選人數 -->
        <b-col v-if="tour.multiPrices === false" cols="12" lg="6">
          <!-- 2.選擇人數 -->
          <div class="pick_ppl mb-4">
            <div class="modal_head">
              <font-awesome-icon icon="fa-solid fa-2"></font-awesome-icon>選擇人數
            </div>
            <div v-if="pickDate === '尚未選擇'">請先選擇日期</div>
            <b-row class="row_p20" v-else>
              <b-col cols="6" lg="7" class="row_p20">
                <span class="identity">成人(6歲以上)</span>
                <!-- <div class="room_type_price">${{orderForm.normalPrice.single.price}} 佔床</div> -->
              </b-col>
              <b-col cols="6" lg="5" class="row_p20">
                <b-form-spinbutton v-model="orderData.adult" id="sb-small" size="sm" inline min="0"></b-form-spinbutton>
              </b-col>
              <b-col cols="6" lg="7" class="row_p20">
                <span class="identity">兒童(2-6歲)</span>
                <!-- <div class="room_type_price">${{orderForm.normalPrice.double.child}}</div> -->
              </b-col>
              <b-col cols="6" lg="5" class="row_p20">
                <b-form-spinbutton v-model="orderData.child" id="sb-small" size="sm" inline min="0"
                  max="1"></b-form-spinbutton>
              </b-col>
              <b-col cols="6" lg="7" class="row_p20">
                <span class="identity">嬰兒(未滿2歲)</span>
                <!-- <div class="room_type_price">${{orderForm.normalPrice.double.baby}}</div> -->
              </b-col>
              <b-col cols="6" lg="5" class="row_p20">
                <b-form-spinbutton v-model="orderData.baby" id="sb-small" size="sm" inline min="0"
                  max="1"></b-form-spinbutton>
              </b-col>
            </b-row>
          </div>

          <!-- 3.確認資訊 -->
          <div class="modal_head">
            <font-awesome-icon icon="fa-solid fa-3"></font-awesome-icon>確認資訊
          </div>
          <b-row class="row_p20">
            <div class="grey_border">團名</div>
            <span class="custom_check">{{ tour.title }}</span>
          </b-row>
          <b-row class="row_p20">
            <div class="grey_border">日期</div>
            <span class="custom_check">{{ pickDate }}</span>
          </b-row>
          <b-row class="row_p20">
            <div class="grey_border">總金額</div>
            <span class="custom_check price">{{ orderData.totalPrice }}</span>
          </b-row>

          <b-row class="row_p20">
            <div class="grey_border">人數</div>
            <span class="custom_check"></span>
            <p>成人 x {{ orderData.adult }}，兒童 x {{ orderData.child }}，嬰兒 x {{ orderData.baby }}</p>
            <!-- <b-table class="mt-1" striped small :items="check_rooms" :fields='fields'>
                    <template #cell(amount)>
                      <p>成人 x {{orderData.adult}}，兒童 x {{orderData.child}}，嬰兒 x {{orderData.baby}}</p>
                    </template>
                  </b-table> -->
          </b-row>
          <!-- 4.確認資訊END -->

        </b-col>
      </b-row>
    </b-modal>
    <!-- 立刻預約modal END -->

    <!-- 寄信 -->
    <b-modal centered id="sendMail" scrollable no-stacking hide-footer title="詢問" @hidden="resetmailData">
      <div class="member_box">
        <!-- 推薦人 -->
        <!-- {{ $store.state.referrer}} -->
        <b-form @submit="sendMailAlert">
          <b-form-group v-if="$store.state.referrer" label='折扣碼' label-cols-md="2" content-cols-sm>
            <div>{{ $store.state.referrer }}</div>
          </b-form-group>
          <b-form-group label='團名' label-cols-md="2" content-cols-sm>
            <div>{{ tour.title }}</div>
          </b-form-group>
          <b-form-group label-for="contact_name" label='聯絡人' label-cols-md="2" content-cols-sm>
            <b-form-input required id="contact_name" v-model="mailData.contact_name"></b-form-input>
          </b-form-group>
          <b-form-group label-for="phone" label='手機' label-cols-md="2" content-cols-sm>
            <b-form-input required id="phone" v-model="mailData.phone"></b-form-input>
          </b-form-group>
          <b-form-group label-for="email" label='email' label-cols-md="2" content-cols-sm>
            <b-form-input required id="email" v-model="mailData.email"></b-form-input>
          </b-form-group>
          <b-form-group required label='內文' label-for='input-body' label-cols-md="2" content-cols-sm>
            <b-form-textarea rows="5" id="input-body" type='text' v-model="mailData.memo"></b-form-textarea>
          </b-form-group>
          <b-form-group :state="checkVCode" invalid-feedback="請輸入正確驗證碼" label='驗證碼' label-for='vali_code'
            label-cols-md="2">
            <b-row>
              <b-col cols="12" class="mb-1">
                <b-form-input :state="checkVCode" id="vali_code" required type='text' placeholder="請輸入下圖的4位數驗證碼"
                  v-model="vali_code" @blur="blur_valiCode = true"></b-form-input>
              </b-col>
              <b-col cols="2">
                <div @click="refreshCode2" style="cursor: pointer;">
                  <Identify2 :identifyCode2="identifyCode2"></Identify2>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
          <div class="text-center mt-4">
            <b-button type="submit" class="btn1" variant="dark">送出</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
    <!-- 予約へ進むmodal  -->
    <b-modal centered id="contact_modal" scrollable no-stacking hide-footer
      :title="$i18n.locale === 'tw' ? '聯絡資訊' : $i18n.locale === 'jp' ? 'お問合わせ窓口' : 'Book Now'">

      <!-- 日文 -->
      <div class="contact_box p-3" v-if="$i18n.locale === 'jp'">
        <div class="text-center">
          <!-- <p>お問合わせ窓口</p> -->
          <img src="@/assets/img/qrcode.png" alt="QRcode" title="QRcode">
          <div>
            <a href="https://lin.ee/g3Cfwi" target="_blank">
              <div class="line_icon"></div>
            </a>
          </div>
          <p>LINE ID：tstar_kao_op2 (翁樣)<br>SKYPE live：kao_op1_1 (翁樣)</p>
        </div>
        <p>ご不明点は、気軽にお問合わせください。サポート・スタッフが迅速に対応いたします！</p>
      </div>

      <!-- 中文 -->
      <div class="contact_box p-3" v-if="$i18n.locale === 'tw'">
        <div class="text-center">
          <img src="@/assets/img/qrcode.png" alt="QRcode" title="QRcode">
          <div>
            <a href="https://lin.ee/g3Cfwi" target="_blank">
              <div class="line_icon"></div>
              <div>加官方Line請點此</div>
            </a>
          </div>
          <div>電話：<a :href="'tel:0225785833'">(02)2578-5833</a></div>
          <div>EMAIL：<a href="mailto: tstar@tstar888.com">tstar@tstar888.com</a></div>
          <div class="mt-3">明日之星旅行社</div>
        </div>
      </div>

      <!-- 英文 -->
      <div class="contact_box p-3" v-if="$i18n.locale === 'en'">
        <div class="text-center">
          <img src="@/assets/img/qrcode.png" alt="QRcode" title="QRcode">
          <div>LINE：
            <a href="https://lin.ee/g3Cfwi" target="_blank">
              <span>Contact us with Line</span>
              <!-- <span class="line_icon"></span> -->
            </a>
          </div>
          <div>EMAIL：<a href="mailto: tstar@tstar888.com">tstar@tstar888.com</a></div>
          <div class="mt-3">Travel Star Service Co.</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Identify2 from '@/components/Identify2.vue'
import 'swiper/css/swiper.css'
export default {
  props: {
    tour: {
      type: Object,
      required: true
    }
  },
  // name: 'ProductPage',
  components: {
    Identify2
  },
  data() {
    // const month = new Date().getMonth()
    // const year = new Date().getFullYear()
    // const prices = [
    //   {
    //     description: '40000',
    //     dates: { weekdays: 6 }, // Every Friday
    //     color: 'orange'
    //   },
    //   {
    //     description: '45000',
    //     // dates: new Date(year, month, 29),
    //     dates: { weekdays: 2 },
    //     color: 'indigo'
    //   }
    // ]
    return {
      blur_valiCode: false,
      identifyCode2: '',
      vali_code: '',
      mailData: {
        contact_name: '',
        phone: '',
        email: '',
        tour_name: '',
        tour_id: '',
        memo: '1.出發日期：\n2.人數：\n3.Line 或微信 ID：\n4.其它事項：'
      },
      // subcategoryUrl: '',
      // 使用者選的日期類別的房間價格
      show_hotel_data: {
        baby: '',
        double: { quantity: '0', adult: '', child: '', detail: '' },
        triple: { quantity: '0', adult: '', child: '', detail: '' },
        four: { quantity: '0', adult: '', child: '', detail: '' },
        five: { quantity: '0', adult: '', child: '', detail: '' },
        six: { quantity: '0', adult: '', child: '', detail: '' }
      },
      // 每個日期各別的資料
      show_day_data: {
        id: '',
        date: '',
        departure_place: '',
        min_people: '',
        max_people: '',
        ps: '',
        signup_people: '',
        available_people: '',
        room: {
          double: { quantity: '0', available: '' },
          triple: { quantity: '0' },
          four: { quantity: '0' },
          five: { quantity: '0' },
          six: { quantity: '0' }
        }
      },
      availableDates: [
        { start: new Date(2023, 3, 10), end: new Date(2023, 3, 20) },
        { start: new Date(2022, 9, 30), end: new Date(2022, 9, 30) }],
      orderForm: {
        tour_id: '',
        id: '',
        date: '',
        detail: '',
        location: '',
        index: -1,
        // date: { date: '', price: '', departure: '', date_memo: '', mark: '' },
        normalPrice: {
          single: { quantity: '1', price: '1000' },
          double: { quantity: '2', adult: '21', child: '22', baby: '23' },
          triple: { quantity: '0', adult: '', child: '', baby: '' },
          four: { quantity: '0', adult: '', child: '', baby: '' },
          standard: { quantity: false }
        },
        holidayPrice: {
          single: { quantity: '0', price: '' },
          double: { quantity: '0', adult: '', child: '', baby: '' },
          triple: { quantity: '0', adult: '', child: '', baby: '' },
          four: { quantity: '0', adult: '', child: '', baby: '' },
          standard: { quantity: false }
        },
        specialPrice: {
          single: { quantity: '0', price: '' },
          double: { quantity: '0', adult: '', child: '', baby: '' },
          triple: { quantity: '0', adult: '', child: '', baby: '' },
          four: { quantity: '0', adult: '', child: '', baby: '' },
          standard: { quantity: false }
        }
      },
      test: [
        {
          highlight: {
            color: 'orange',
            fillMode: 'light'
          },
          dates: ['2022-11-10'],
          memo: '9人成行',
          price: '42000',
          priceType: '自填'
        },
        {
          // key: 'today',
          highlight: {
            color: 'green',
            fillMode: 'light'
          },
          dates: ['2023-01-27']
        },
        {
          // key: 'today',
          highlight: {
            color: 'red',
            fillMode: 'light'
          },
          dates: ['2022-11-28']
        },
        {
          key: 'd1',
          highlight: {
            color: 'blue',
            fillMode: 'light'
          },
          dates: { weekdays: 3 }
        }
      ],
      fields: [
        { key: 'roomstyle', label: '房型', class: 'td' },
        { key: 'amount', label: '人數', class: 'td' }
      ],
      check_rooms: [
      ],
      attributes: [],
      // 月曆價錢
      // prices,
      // 連動月曆選擇日期
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD'
      },
      // 月曆選擇日期後，顯示在確認資訊中
      pickDate: '尚未選擇',
      // 房間數
      singleRoom: 1,
      doubleRoom: 0,
      // 單人房人數
      single: {
        singleAdult: 0
      },
      // 雙人房人數
      double: [],

      // 存訂單資訊
      orderData: {
        tourTitle: '',
        tourId: '', // 團ID
        pickDate: '', // 日期
        totalPrice: '',
        // 房間數
        doubleRoom: 0,
        // 人數
        double: [{
          doubleAdult: 0,
          doubleChild: 0,
          doubleBaby: 0
        }],
        // 存人數(如果多房型價格，人數要加總到這邊)
        adult: 0,
        child: 0,
        baby: 0
      },
      isAble: false,
      share: {
        copyUrl: 'https://tstar888.com/JP2TW/product/',
        fb: 'https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=https%3A%2F%2Ftstar888.com%2FJP2TW%2F%3Fid%3DJPN22001&display=popup&ref=plugin&src=share_button'
      }
    }
  },
  watch: {
    // 監視使用者選日期的值是否有變更
    pickDate() {
      // for (let i = 0; i < this.normal.dates.length; i++) {
      //   if (this.normal.dates[i] === this.pickDate) {
      //     this.pickDate = '平日'
      //   }
      // }
      // 使用者選日期後，找日期是哪種價錢分類，再找符合分類的旅館資料
      for (let i = 0; i < this.tour.dates.length; i++) {
        for (let x = 0; x < this.tour.dates[i].dates.length; x++) {
          if (this.pickDate === this.tour.dates[i].dates[x]) {
            if (this.tour.dates[i].priceType === '平日') {
              this.show_hotel_data = this.tour.normalPrice
              // alert('/平日')
            } else if (this.tour.dates[i].priceType === '例假日') {
              this.show_hotel_data = this.tour.holidayPrice
            } else if (this.tour.dates[i].priceType === '特殊價格') {
              this.show_hotel_data = this.tour.specialPrice
            } else if (this.tour.dates[i].priceType === '自填價格') {
              this.show_hotel_data = this.tour.dates[i].price
            }
            break
          } else this.show_hotel_data = ''
        }
      }
      // 使用者選日期後，找該日期的資料
      for (let i = 0; i < this.tour.data_eachday.length; i++) {
        if (this.pickDate === this.tour.data_eachday[i].date) {
          this.show_day_data = this.tour.data_eachday[i]
        } else {
          this.show_day_data = {
            id: '',
            date: '',
            departure_place: '',
            min_people: '',
            max_people: '',
            ps: '',
            signup_people: '',
            available_people: '',
            room: {
              double: { quantity: '0', available: '' },
              triple: { quantity: '0' },
              four: { quantity: '0' },
              five: { quantity: '0' },
              six: { quantity: '0' }
            }
          }
        }
      }
      // 如果取消選取日期，清除其他選取的項目
      if (this.pickDate === '') {
        this.doubleRoom = 0
        this.show_day_data = ''
        this.pickDate = '尚未選擇'
      }
    },
    // 監視房間數量是否有變，連動確認資訊的表格
    doubleRoom(n, o) {
      // 增加房間
      if (o < n) {
        this.check_rooms = []
        for (let i = 1; i <= this.doubleRoom; i++) {
          this.double.push({
            doubleAdult: 0,
            doubleChild: 0,
            doubleBaby: 0
          })
          this.check_rooms.push(
            {
              roomstyle: '雙人房' + i,
              amount: ''
            }
          )
        }
        // 減少房間
      } else if (o > n) {
        console.log('減少房間')
        this.check_rooms.splice(this.check_rooms.length - 1, 1)
      }
    }
  },
  computed: {
    // 尋找球場的地區ID
    golfAreaId() {
      // console.log('golfArea')
      const golfArea = this.tour.schedule.find(day => day.golf.title)?.golf.area_id
      // console.log(golfArea)
      return golfArea
    },
    // 尋找旅館的地區ID
    hotelAreaId() {
      const hotelArea = this.tour.schedule.find(day => day.hotel.title)?.hotel.area_id
      // console.log(hotelArea)
      return hotelArea
    },
    checkVCode() {
      return !this.blur_valiCode ? null : this.vali_code === this.identifyCode2
    },
    auto() {
      return this.double.doubleAdult
    },
    // checkRooms () {
    //   for (let i = 0; i < this.doubleRoom; i++) {
    //     this.check_rooms[i].roomstyle = '雙人房' + i
    //   }
    //   return this.check_rooms
    // },
    check() {
      if (this.doubleBaby === 0) {
        return this.isAble === true
      } else {
        return this.isAble === false
      }
    }
    // attributes () {
    //   return [
    //     // Attributes for prices
    //     ...this.prices.map(price => ({
    //       dates: price.dates,
    //       dot: {
    //         color: price.color
    //       },
    //       // popover: {
    //       //   label: price.description
    //       // },
    //       customData: price
    //     }))
    //   ]
    // }
  },
  methods: {
    resetmailData() {
      this.mailData = {
        contact_name: '',
        phone: '',
        email: '',
        tour_name: '',
        tour_id: '',
        memo: '1.出發日期：\n2.人數：\n3.其它事項：'
      }
      this.blur_valiCode = false
      this.refreshCode2()
      this.vali_code = ''
    },
    // 寄信前先確認並詢問
    sendMailAlert(event) {
      event.preventDefault()
      console.log(this.$store.state.referrer)
      console.log(this.checkVCode)
      if (!this.checkVCode) return
      if (this.mailData.memo.length < 12) {
        alert('請填寫完整信件內文')
        return
      }
      this.$swal({
        text: '確定要寄出信件?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.value) {
          this.$bvModal.show('waitModal')
          this.sendMail()
        }
      })
    },
    // 寄信
    async sendMail() {
      this.mailData.tour_name = this.tour.title
      this.mailData.tour_id = this.tour.id
      this.mailData.discount_code = this.$store.state.referrer
      // 推薦碼
      console.log(this.mailData)
      try {
        const { data } = await this.api.post(
          'php_modules2/comment.php?type=c', this.mailData)
        console.log(data)
        if (data.success) {
          await this.$swal({
            icon: 'success',
            text: '寄信成功',
            showConfirmButton: false,
            timer: 1500
          })
          this.$bvModal.hide('waitModal')
          this.$bvModal.hide('sendMail')
        } else alert(data.message)
      } catch (error) {
        alert(error)
      }
    },
    // 立刻預約MODAL按下一步後，去結帳頁
    async goCheckout() {
      // 把團的資料跟客人選的資料存進localStorage
      this.orderData.tourId = this.$route.params.id
      this.orderData.tourTitle = this.tour.title
      console.log(this.tour.title)
      this.orderData.pickDate = this.pickDate
      const orderData = JSON.stringify(this.orderData)
      localStorage.setItem('tstarTravel', orderData)
      this.$router.push('/checkout/' + this.tour.id)
    },
    resetForm() {
      // if (this.modalSubmiaddImging) {
      //   event.preventDefault()
      //   return
      // }
      this.orderForm = {
        title: '',
        detail: '',
        category: '',
        id: '',
        img: ''
      }
      this.images = null
    }
  },
  mounted() {
    this.refreshCode2()
    // if (this.$store.state.user.email === 'it1@gwls.com.tw') {
    //   console.log('sendMail')
    //   this.$bvModal.show('sendMail')
    // }
    // console.log(this.tour.subcategoryUrl)
    this.attributes = this.test
  }
}
</script>

<style lang="scss">
#contact_modal {
  letter-spacing: 1px;

  .line_icon {
    display: inline-block;
  }

  a {
    border-radius: 30px;
    width: 40px;
    height: 40px;
  }

  .modal-title {
    text-align: center;
  }
}

#calendar_modal {
  .modal_head {
    background-color: var(--myblue2);
    padding: 5px;
    border-radius: 9px 9px 0 0;
    margin-bottom: .5rem;
    letter-spacing: 1px;
    font-weight: 500;
    line-height: 24px;
    color: var(--myblue);

    svg {
      margin: 0 8px;
    }
  }

  .modal-title {
    letter-spacing: 1px;
    font-size: 1rem;
    font-weight: 500;
    color: var(--myblue);
  }

  .mark_box {
    display: flex;
    align-items: center;
    margin-right: 1.2rem;
    margin-bottom: 4px;
    font-weight: 500;
    font-size: .9rem;
  }

  .dot_mark {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #bee3f8;
    display: inline-block;
    margin-right: 7px;
  }

  .mark_1 {
    background-color: #5a67d8;
  }

  .date_info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: .3rem;

    .mark_box:nth-child(2) .dot_mark {
      background-color: #fed7d7;
    }

    // .mark_box:nth-child(2) .dot_mark {
    //   background-color: #c6f6d5;
    // }
    // .mark_box:nth-child(3) .dot_mark {
    //   background-color: #feebc8;
    // }
    // .mark_box:nth-child(4) .dot_mark {
    //   background-color: #fed7d7;
    // }
  }

  .grey_border {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 5px;
    margin: 0 5px 5px 0;
    border: 1px solid rgb(216, 216, 216);
    font-weight: 500;
  }

  .can_sell {
    color: var(--myblue);
  }

  .custom_check {
    line-height: 30px;
    font-weight: 500;
  }

  .price {
    color: #f5553f;
    font-size: 1.2rem;
  }

  .is-disabled {
    cursor: auto;
  }

  .modal-body {
    h6 {
      // border-bottom: 2px solid #fff;
      // background-color: #dee2ec;
      padding: 5px;
    }
  }

  .modal-footer {
    justify-content: space-between;

    button {
      border-radius: 50px;
      padding: .5rem 1.8rem;
    }
  }

  .form-control.focus {
    outline: none;
    box-shadow: none;
  }

  table {
    margin: 0 20px;
  }

  .pick_rooms {
    border-left: 4px solid rgb(216, 216, 216);
    margin-bottom: 8px;
    padding-left: 3px;
  }

  .btn-primary {
    background-color: var(--myblue) !important;
    border: none;
  }

  #footer_info_date {
    color: #5f5f5f;
  }
}

#title_part {

  .product_price {
    font-size: 1.8rem;
  }

  // color: #444955;
  // font-size: 1.2rem;
  .product_title {
    // color: var(--mytitle);
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 2rem;
    letter-spacing: .5px;
    margin-bottom: 1rem;
  }

  .dayTag {
    color: rgb(90, 90, 90);
    // font-size: .9rem;
    // border: 1px solid;
    background-color: var(--myblue2);
    border-radius: 5px;
    padding: 3px 6px;
    display: inline-block;
    margin: calc(1rem + 2vw) 0 .8rem;
  }

  // .feature::before{
  //   content: "";
  //   z-index: -1;
  //   background-color: var(--myblue2);
  //   width: 100%;
  //   height: 100%;
  //   right: 0;
  //   position: absolute;
  //   display: block;
  // }
  .feature {

    // padding: 0 6rem 0 4rem;
    @media (min-width:768px) {
      padding: 0 6rem 0 4rem;
    }
  }

  .feature h6 {
    font-weight: bold;
    display: inline-block;
    // border-bottom: 3px solid var(--myblue);
    color: var(--mytitle);
    font-size: 1.1rem;
    letter-spacing: 1px;
  }

  .feature li {
    list-style: circle;
    letter-spacing: .5px;
    line-height: 1.6rem;
    margin: 6px 0;
  }

  .book_btn {
    border: none;
    font-size: 1.2rem;
    padding: .6rem 1.5rem;
    letter-spacing: 1.5px;
    font-weight: 500;
    color: #fff;
    box-shadow: 4px 4px 0 #dbdbdb;
    background-color: var(--accent);
    transition: .3s;
    margin: 1.5rem .5rem .5rem;

    &:hover {
      transform: translate(4px, 4px);
      box-shadow: none;
    }
  }

  .bg_orange {
    background-color: var(--orange_title);
  }

  .share_Link {
    display: flex;
    flex-direction: column;
    align-items: center;

    & img {
      width: 100px;
      border-radius: 5px;
      cursor: pointer;
      margin: 0 5px 5px 2px;
    }
  }

  .share_link {
    display: flex;
    align-items: center;
  }

  .fa_icon {
    font-size: 2.2rem;
    margin: 0 .3rem;
  }

  .fa-line {
    color: #00B900;
  }

  .fa-facebook-square {
    color: #0165E1;
  }

  .share_txt {
    font-size: .9rem;
    font-weight: 500;
    margin-right: .6rem;
  }

  .copy_link,
  .dm {
    font-weight: bold;
    font-size: .9rem;
    display: inline-block;
    padding: 0 4px;
    height: 31px;
    margin: 0 .3rem;
    text-align: center;
    line-height: 31px;
    border-radius: 5px;
    color: #fff;
    background-color: var(--orange);
  }

  .dm {
    background-color: var(--myred);
  }

  // .modal {
  //   padding-right: 0px !important;
  // }

  // checked box 勾選顏色
  // .custom-control-input:checked ~ .custom-control-label::before {
  //   background-color: var(--myblue);
  //   border: var(--myblue);
  // }
  @media (min-width:576px) {
    .product_title {
      font-size: 1.5rem;
    }
  }

  @media (min-width:992px) {}
}

// .room_btn .btn {
//   background-color: #fff;
//   border: 1px solid var(--myblue);
//   color: var(--myblue);
//   &.focus {
//     outline: none;
//     box-shadow: none;
//   }
// }

// vs-accordion 摺疊樣式
.vs-accordion {
  h6 {
    margin: 0;
  }
}

.vs-accordion__trigger {
  background-color: #dee2ec;
  --vs-accordion-padding: 10px 5px;
  margin-bottom: 1px;
}

.vs-accordion__content {
  // background-color: #d2d7e7;
  padding: 5px 0 0;

  .col-3 {
    flex-direction: column;
  }

  .row {
    padding: 2px 0;
  }
}

.identity {
  font-size: .9rem;
}

.room_type_price {
  font-size: .7rem;
  color: #999999;
}

#sendMail {
  .col-sm {
    display: flex;
    align-items: center;
  }
}
</style>
